import { Pipe, PipeTransform } from '@angular/core';
import { AudioSpeed, AudioSpeedReverse } from '@dataclouder/ngx-core';

export const SpeedDescription = {
  1: 'Muy Lento',
  2: 'Lento',
  3: 'Normal',
  4: 'Rápida',
  5: 'Muy Rápida',
};

@Pipe({
  name: 'speedDisplay',
  standalone: true,
})
export class SpeedDescPipe implements PipeTransform {
  transform(speed: any): string {
    return AudioSpeedReverse[speed];
  }
}
